import { Component, OnInit } from '@angular/core';
import { CallBackModel, config, EcashService, LoggingService, PurchaseService } from '@fgb/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'fgb-cart-checkout-results-page',
  templateUrl: './cart-checkout-results-page.component.html',
  styleUrls: ['./cart-checkout-results-page.component.scss'],
})
export class CartCheckoutResultsPageComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private logService: LoggingService,
    private ecashService: EcashService,
    private purchaseService: PurchaseService,
    public router: Router
  ) { }

  isCallbackProvider: boolean = false;

  ngOnInit() {
    let orderId: string | null = null;
    if (this.route.snapshot.queryParamMap.keys.map(x => x.toUpperCase()).includes('ORDERID')) {
      const orderIdQueryStringKey = this.route.snapshot.queryParamMap.keys.filter(x => x.toUpperCase() === 'ORDERID')[0];
      orderId = this.route.snapshot.queryParamMap.get(orderIdQueryStringKey);
    }

    if (!orderId) {
      this.logService.error('No order ID could be found in the query string');
      return;
    }

    if (!this.isCallbackProvider) {
      this.ecashService.callBack(new CallBackModel('', config.baseApiUrl + this.router.url)).subscribe(response => {
        if (response.Success) {
          this.router.navigate(['rewards/marketplace/purchase/success'], { queryParams: { purchaseOrderId: orderId } });
        } else {
          this.router.navigateByUrl('/portalproducts/failure');
        }
      });
    } else {
      this.purchaseService.checkOrderSuccessStatus(orderId, 'rewards/marketplace/purchase/success', '/portalproducts/failure');
    }
  }
}
